import ConsumerHeader from "@/components/consumer/landing/ConsumerHeader";
import ConsumerHero from "@/components/consumer/landing/ConsumerHero";
import ConsumerBenefits from "@/components/consumer/landing/ConsumerBenefits";
import ConsumerHowItWorks from "@/components/consumer/landing/ConsumerHowItWorks";
import ConsumerTargetAudience from "@/components/consumer/landing/ConsumerTargetAudience";
import ConsumerDifference from "@/components/consumer/landing/ConsumerDifference";
import ConsumerSellerNetSheet from "@/components/consumer/landing/ConsumerSellerNetSheet";
import ConsumerFAQ from "@/components/consumer/landing/ConsumerFAQ";
import ConsumerCTA from "@/components/consumer/landing/ConsumerCTA";
import ConsumerFooter from "@/components/consumer/landing/ConsumerFooter";
import PageSEO from "@/components/seo/PageSEO";
import StructuredData from "@/components/seo/StructuredData";

const ConsumerLandingPage = () => {
  return (
    <div className="min-h-screen bg-[#080c14] text-white">
      <PageSEO
        title="Sell Your House Fast for Cash | No Fees | GoDyspo"
        description="Get a free home valuation and connect with cash buyers. Sell your property fast with no fees, no repairs, no hassle. Professional marketing included."
        canonical="/consumer"
        keywords="sell house fast, cash home buyers, sell my house for cash, quick home sale, we buy houses, sell property fast, no agent fees"
      />
      <StructuredData 
        type="BreadcrumbList" 
        breadcrumbs={[
          { name: "Home", url: "/" },
          { name: "For Homeowners", url: "/consumer" }
        ]} 
      />
      <ConsumerHeader />
      <div className="max-w-screen-2xl mx-auto">
        <ConsumerHero />
        <ConsumerBenefits />
        <ConsumerHowItWorks />
        <ConsumerTargetAudience />
        <ConsumerDifference />
        <ConsumerSellerNetSheet />
        <ConsumerFAQ />
        <ConsumerCTA />
      </div>
      <ConsumerFooter />
    </div>
  );
};

export default ConsumerLandingPage;
